module.exports = __webpack_public_path__ + "img/logo-header2.12e70b3e.png";